import { makeStyles } from 'tss-react/mui';

const useStylesTableRowForm: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  tableRowForm: {
    '& > td': {
      borderRight: `1px solid ${theme.palette.info.main}`,
    },
  },
  tableRowFormActive: {
    '& > td': {
      backgroundColor: `${theme.palette.secondary.light} !important`,
    },
    '&:hover > td': {
      backgroundColor: `${theme.palette.secondary.light} !important`,
    },
  },
  tableRowFormNoBorders: {
    '& > td': {
      borderRight: 'none',
    },
  },
}));

export default useStylesTableRowForm;
